export function getTransferFormData(state) {
  return {
    receiverLicense: state.receiverLicense,
    pickUpDate: state.pickUpDate,
    dropOffDate: state.dropOffDate,
    isDropOff: state.isDropOff,
    packageModel: state.packageModel,
    packageTiming: state.packageTiming,
  };
}
